import { Row, Col, Image, Card, Empty, Spin } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams } from 'react-router-dom'
import { getInspirationGalleryImageByIdData } from './store/inspirationGallery/inspiration-gallery-slice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './css/inspiration-gallery-layout.css'

export const INSPIRATION_DETAIL_SCROLL_ID = 'inspiration-detail-scroll'

const isMobilePlatform = (platform) =>
    String(platform ?? '')
        .trim()
        .toLowerCase() === 'mobile'

const InspirationGallery = () => {
    const dispatch = useDispatch()
    const { id } = useParams()

    const {
        inspirationGalleryDetails,
        inspirationGalleryImageList,
        isImageNext,
    } = useSelector((state) => state.inspirationGallerySlice)

    const isMobileGallery = isMobilePlatform(
        inspirationGalleryDetails?.platform
    )

    const [page, setPage] = useState(1)

    useEffect(() => {
        if (id) {
            dispatch(
                getInspirationGalleryImageByIdData({
                    id,
                    skip: 0,
                    limit: 12,
                })
            )
            setPage(1)
        }
    }, [id, dispatch])

    const loadMore = () => {
        if (!isImageNext) return

        const nextPage = page + 12
        setPage(nextPage)
        dispatch(
            getInspirationGalleryImageByIdData({
                id,
                skip: nextPage,
                limit: 12,
            })
        )
    }

    const imageGridClassName = `inspiration-image-grid${
        isMobileGallery ? ' inspiration-image-grid--mobile-full' : ''
    }`

    const imageGrid = inspirationGalleryImageList.map((item) => (
        <Col key={item._id} xs={24} sm={12} md={8} lg={6} xl={6}>
            <Card
                className={`inspiration-image-card${
                    isMobileGallery ? ' inspiration-image-card--mobile-full' : ''
                }`}
                bodyStyle={{
                    padding: 0,
                    height: isMobileGallery ? 'auto' : '100%',
                }}
                hoverable
            >
                <Image
                    src={item.imageUrl}
                    alt={item.caption || ''}
                    preview={{
                        mask: item.caption,
                        title: item.caption,
                    }}
                    loading="lazy"
                />
            </Card>
        </Col>
    ))

    return (
        <InfiniteScroll
            dataLength={inspirationGalleryImageList.length}
            next={loadMore}
            hasMore={isImageNext}
            scrollableTarget={INSPIRATION_DETAIL_SCROLL_ID}
            style={{ overflow: 'visible' }}
            loader={
                <div
                    className="inspiration-gallery-bottom-loader"
                    role="status"
                    aria-live="polite"
                >
                    <Spin size="small" />
                    <span className="inspiration-gallery-bottom-loader__text">
                        Loading more images…
                    </span>
                </div>
            }
        >
            {inspirationGalleryImageList.length === 0 ? (
                <Row gutter={[20, 20]} className={imageGridClassName}>
                    <Col span={24}>
                        <div className="inspiration-detail-images-empty">
                            <Empty
                                description="No screenshots in this gallery yet"
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                            />
                        </div>
                    </Col>
                </Row>
            ) : (
                <Image.PreviewGroup
                    preview={{
                        showRotate: true,
                        showZoom: true,
                    }}
                >
                    <Row gutter={[20, 20]} className={imageGridClassName}>
                        {imageGrid}
                    </Row>
                </Image.PreviewGroup>
            )}
        </InfiniteScroll>
    )
}

export default InspirationGallery
